/* HIT na Trávenie+® — 2Advanced scroll layer (see assets/iprobio-hit-motion.css for the grammar), 2026-10-14,
   pared back 2026-10-22. Takes over every .gsap-reveal piece and the dosing cards (.dose-in); GSAP only runs the hero
   entrance (section script). Adds only aria-hidden decoration, never text. */
(function () {
    'use strict';
    var d = document, w = window, html = d.documentElement;
    if (w.__h2aMotion) return;
    w.__h2aMotion = true;
    html.classList.add('h2a-js');
    var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var CARD = '.problem-card,.diff-card,.pillar-card,.strain-card,.expert-card,.persona-card,.evidence-block,.cross-card';
    var MEDIA = '.founder-player,.capsule-visual';
    var pieces = [].slice.call(d.querySelectorAll('.gsap-reveal, .dose-in'));
    var rows = [].slice.call(d.querySelectorAll('.comparison-table tbody tr'));

    function cs(el, pseudo) { return w.getComputedStyle(el, pseudo || null); }
    /* Making a static box `position: relative` is only safe if nothing positioned inside it (or its own ::before/::after)
       currently resolves against an outer box. */
    function safeToPosition(el) {
        if (cs(el).position !== 'static') return true;
        if (cs(el, '::before').position === 'absolute' || cs(el, '::after').position === 'absolute') return false;
        var all = el.querySelectorAll('*');
        for (var i = 0; i < all.length; i++) {
            var pos = cs(all[i]).position;
            if (pos !== 'absolute' && pos !== 'fixed') continue;
            if (pos === 'fixed') continue;
            var p = all[i].parentElement, contained = false;
            while (p && p !== el) { if (cs(p).position !== 'static') { contained = true; break; } p = p.parentElement; }
            if (!contained) return false;
        }
        return true;
    }
    function add(el, cls, html) {
        var s = d.createElement('span');
        s.className = cls; s.setAttribute('aria-hidden', 'true');
        if (html) s.innerHTML = html;
        el.appendChild(s);
    }
    function decorate(el, role) {
        if (reduce) return;
        if (!safeToPosition(el)) return;
        if (cs(el).position === 'static') el.classList.add('h2a-rel');
        if (role === 'head') { add(el, 'h2a-hair'); return; }
        if (cs(el).overflow !== 'visible') el.classList.add('h2a-tight');
        add(el, 'h2a-corners', '<i></i><i></i><i></i><i></i>');
    }

    pieces.forEach(function (el) {
        var role = el.matches('.section-header') ? 'head' : el.matches(CARD) ? 'card' : el.matches(MEDIA) ? 'media' : 'block';
        el.setAttribute('data-h2a', role);
        if (role !== 'block') decorate(el, role);
    });
    rows.forEach(function (tr) { tr.setAttribute('data-h2a', 'row'); });

    function show(el) {
        el.classList.add('h2a-in');
        var delay = parseInt(el.style.getPropertyValue('--h2a-d') || '0', 10) || 0;
        w.setTimeout(function () { el.classList.add('h2a-done'); }, reduce ? 0 : delay + 1700);
    }
    if (reduce || !('IntersectionObserver' in w)) {
        pieces.forEach(show); rows.forEach(show);
        return;
    }

    /* Pieces that arrive in the same moment form a batch; side-by-side pieces cascade (≤ 400 ms total), stacked ones
       (phones, single columns) get no delay, so each reveals in view on its own. */
    var batch = [], scheduled = false;
    function flush() {
        scheduled = false;
        var list = batch.splice(0, batch.length);
        list.sort(function (a, b) { return a.compareDocumentPosition(b) & 4 ? -1 : 1; });
        var lastTop = null, k = 0;
        list.forEach(function (el) {
            var top = Math.round(el.getBoundingClientRect().top);
            k = (lastTop !== null && Math.abs(top - lastTop) < 40) ? k + 1 : 0;   /* same row → cascade */
            lastTop = top;
            el.style.setProperty('--h2a-d', Math.min(k, 5) * 90 + 'ms');
            show(el);
        });
    }
    function queue(el) {
        batch.push(el);
        if (!scheduled) { scheduled = true; w.requestAnimationFrame(flush); w.setTimeout(function () { if (scheduled) flush(); }, 60); }
    }
    var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            io.unobserve(e.target);
            queue(e.target);
        });
    }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
    pieces.forEach(function (el) { io.observe(el); });
    var rio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            rio.unobserve(e.target);
            var i = rows.indexOf(e.target);
            e.target.style.setProperty('--h2a-d', (w.innerWidth >= 900 ? Math.min(i % 6, 5) * 70 : 0) + 'ms');
            show(e.target);
        });
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
    rows.forEach(function (tr) { rio.observe(tr); });

    /* anything already above the fold on load (deep link / restored scroll) */
    w.addEventListener('load', function () {
        pieces.concat(rows).forEach(function (el) {
            if (el.classList.contains('h2a-in')) return;
            var r = el.getBoundingClientRect();
            if (r.bottom < 0) show(el);
        });
    });
})();
